import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { localBusinessSchema } from "../components/seoSchemas";
import { site } from "../data/site";

export default function AboutPage() {
  return (
    <>
      <SEO
        title="About Polishing Singapore | Stone Polishing Specialists"
        description="Polishing Singapore provides stone polishing, restoration and cleaning for marble, granite, terrazzo, quartz, natural stone, tile, parquet and concrete surfaces."
        canonical={`${site.domain}/about`}
        jsonLd={localBusinessSchema()}
      />
      <PageHero title="About Polishing Singapore" description="Stone polishing, restoration and cleaning specialists for residential, office and commercial surfaces in Singapore." image="/assets/polishing/about_surface_samples.webp" />
      <section className="section-pad bg-background-50">
        <div className="section-shell grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
          <div className="surface-card overflow-hidden">
            <img src="/assets/polishing/contact.webp" alt="Polishing work preparation" className="h-[520px] w-full object-cover" />
          </div>
          <article className="surface-card p-6 md:p-10">
            <p className="eyebrow">Company profile</p>
            <h2 className="mt-3 font-heading text-4xl font-bold">Stone care services organized around polishing, restoration, repair, cleaning and maintenance.</h2>
            <div className="prose-polishing mt-6">
              {site.aboutParagraphs.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          </article>
        </div>
      </section>
    </>
  );
}
